import React, { Component, Fragment } from 'react';
import Slider from 'react-slick';

import worksSliderImg1 from 'images/works-slider-img1.png';
import worksSliderImg2 from 'images/works-slider-img2.png';
import worksSliderImg3 from 'images/works-slider-img3.png';
import worksSliderImg4 from 'images/works-slider-img4.png';
import imgLine1 from 'images/line-dashed1.svg';
import imgLine2 from 'images/line-dashed2.svg';
import imgLine3 from 'images/line-dashed3.svg';
import iPhone10 from 'images/iPhone10.svg';

const SlidernavItm = ({ onClick, className, title, text, imgLineSrc }) => {
  return (
    <div onClick={onClick} className={className}>
      <div className="works-slidernav__line">
        <img src={imgLineSrc} alt="" />
      </div>
      <h3 className="works-slidernav__title">{title}</h3>
      <p className="works-slidernav__text">{text}</p>
    </div>
  );
};

const SliderItm = ({ imgSrc }) => {
  return (
    <div className="works-slider__frame">
      <div className="works-slider__img">
        <img src={iPhone10} alt="" />
      </div>
      <div className="works-slider__img-inner">
        <img src={imgSrc} alt="" />
      </div>
      <div className="works-slider__circle" />
    </div>
  );
};

class MakeItYours extends Component {
  state = {
    nav1: null,
    nav2: null,
  };

  sliderKey1 = React.createRef();
  sliderKey2 = React.createRef();

  componentDidMount() {
    this.setState({
      nav1: this.sliderKey1.current,
      nav2: this.sliderKey2.current,
    });
  }

  static propTypes = {};

  handleChangeSlide = v => {
    this.slider.slickGoTo(v);
  };

  render() {
    var settings = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      fade: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      slidesToScroll: 1,
      initialSlide: 2,
      // asNavFor: this.state.nav2,
    };

    var settingsNav = {
      slidesToShow: 4,
      initialSlide: 2,
      swipeToSlide: true,
      focusOnSelect: true,
      pauseOnHover: true,
      // asNavFor: this.state.nav1,
    };

    return (
      <Fragment>
        <div className="makeIt">
          <div className="h2-title big center">Make it yours</div>
          <div className="makeIt__content">
            <div className="works-slider">
              <Slider {...settings} ref={slider => (this.slider = slider)}>
                <SliderItm imgSrc={worksSliderImg1} />
                <SliderItm imgSrc={worksSliderImg2} />
                <SliderItm imgSrc={worksSliderImg3} />
                <SliderItm imgSrc={worksSliderImg4} />
              </Slider>
            </div>
            <div className="works-slidernav">
              <Slider {...settingsNav} ref={this.sliderKey2}>
                <SlidernavItm
                  onClick={() => this.handleChangeSlide(0)}
                  className="works-slidernav__itm step1"
                  title="Create"
                  text="Sign in to create your own custom InstaLinks Page.
                                    Your InstaLinks Page can be shared with any of your
                                    social networks using a single, customizable short URL."
                />
                <SlidernavItm
                  onClick={() => this.handleChangeSlide(1)}
                  className="works-slidernav__itm step2"
                  title="Share"
                  text="Place your URL in your social media bio,
                                    email signature, website, resume, or anywhere
                                    else URLs can be shared."
                />
                <SlidernavItm
                  onClick={() => this.handleChangeSlide(2)}
                  className="works-slidernav__itm right step3"
                  title="Image links"
                  text="Place your InstaLinks URL in your social media bio, email signature, website, resume, or anywhere else URLs can be shared."
                />
                <SlidernavItm
                  onClick={() => this.handleChangeSlide(3)}
                  className="works-slidernav__itm right step4"
                  title="Customize"
                  text="Choose all the links you would like show up on
                                    your InstaLinks Page. You can add your website, blog,
                                    social accounts, affiliate links, Kickstarter
                                    projects, favorite products, or anything else
                                    you want to share with your audience."
                />
              </Slider>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MakeItYours;



// WEBPACK FOOTER //
// ./src/components/MakeItYours/MakeItYours.js